<template>
  <section>
    <Landing />
  </section>
  <Footer />
</template>

<script>
  import axios from "axios";
  import Landing from "@/components/Landing";
  import Footer from "@/components/Footer";
  import Button from "@/components/Button";
  export default {
    name: "Home",
    components: {
      Landing,
      Footer,
      Button,
    },
    data() {
      return {
      };
    },
    methods: {
    }
  };
</script>

<style lang="scss" scoped>
  section {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  a {
    margin-top: 36px;
  }
</style>